import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AddButton from "@components/buttons/AddButton";
import ModalUpsertUnavailability from "./ModalUpsertUnavailability";

export default function UnavailabilityForm(props) {
  const { t: translator } = useTranslation("pages.employés.emploi&Salary");
  const [_showModalAddUnavailability, setShowModalAddUnavailability] = useState(false);

  const openModalUnavailability = () => {
    setShowModalAddUnavailability(true);
  }

  const closeModalUnavailability = () => {
    setShowModalAddUnavailability(false);
  }

  return (
    <div className="arh-mb-8">
      <AddButton
        label={translator("Ajouter une période d'indisponibilité")}
        onClick={openModalUnavailability}
        color="arh-bg-greenColor hover:arh-bg-darkGreenColor"
        labelClass="arh-text-xs"
        disabled={false}
      />
      <ModalUpsertUnavailability
        refreshUnavailabilityList={props.refreshUnavailabilityList}
        employeeId={props.employeeId}
        isOpen={_showModalAddUnavailability}
        closeModal={closeModalUnavailability}
        unavailabilityList={props.unavailabilityList}
      />
    </div>
  );
}
